/**
 * @generated SignedSource<<54202e1357fcf3826586d12888d1309a>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type NavigationMenuClubCard_session$data = {
  readonly currentClientProfile: {
    readonly member: {
      readonly club: {
        readonly appCustomization: {
          readonly backgroundImage: {
            readonly publicId: string;
          } | null | undefined;
        } | null | undefined;
        readonly id: string;
        readonly name: string;
        readonly " $fragmentSpreads": FragmentRefs<"FacilityLogoSideNavFragment_club">;
      };
    } | null | undefined;
  } | null | undefined;
  readonly " $fragmentSpreads": FragmentRefs<"BookButtonHomeHeader_session">;
  readonly " $fragmentType": "NavigationMenuClubCard_session";
};
export type NavigationMenuClubCard_session$key = {
  readonly " $data"?: NavigationMenuClubCard_session$data;
  readonly " $fragmentSpreads": FragmentRefs<"NavigationMenuClubCard_session">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "NavigationMenuClubCard_session",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "BookButtonHomeHeader_session"
    },
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "currentClientProfile",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": null,
          "kind": "LinkedField",
          "name": "member",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "Club",
              "kind": "LinkedField",
              "name": "club",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "id",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "name",
                  "storageKey": null
                },
                {
                  "args": null,
                  "kind": "FragmentSpread",
                  "name": "FacilityLogoSideNavFragment_club"
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "AppCustomization",
                  "kind": "LinkedField",
                  "name": "appCustomization",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "Image",
                      "kind": "LinkedField",
                      "name": "backgroundImage",
                      "plural": false,
                      "selections": [
                        {
                          "alias": "publicId",
                          "args": null,
                          "kind": "ScalarField",
                          "name": "renderingKey",
                          "storageKey": null
                        }
                      ],
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Session",
  "abstractKey": null
};

(node as any).hash = "69d890aa1d414ea85986c1331c825d00";

export default node;
